<template>
  <div class="list-content">
    <div class="order-list">
      <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="nextPage">
        <van-cell v-for="(item, index) in list" :key="index">
          <div class="time-top" v-if="item.nowDayToBirthday">
            <img src="@/static/images/order/time-01.png" />
            <span v-html="item.nowDayToBirthday"></span>
          </div>
          <div class="list-item" @click.stop="goDetail(item)">
            <div class="top-box">
              <div class="text">投保时间：{{ item.holdTime | transformTime | timeSub(16) }}</div>
              <div
                class="tag"
                :class="{
                  'orange': item.orderStatus == 1 && item.checkInsuranceStatus == 1,
                  'blue': [1].includes(item.policyStatus * 1) || (item.orderStatus == 1 && item.checkInsuranceStatus == 2) || item.orderStatus == 2
                }"
              >
                <span>{{ item.statusDesc == '待支付' ? '未支付' : item.statusDesc }}</span>
                <span v-if="item.statusDesc == '已承保' || item.statusDesc == '已终止'">{{ showReceiptRevisit(item) }}</span>
              </div>
            </div>
            <div class="content-box">
              <div class="title">{{ item.productName }}</div>
              <div class="left-box" :class="{ 'full': !showRightBox(item) }">
                <div class="text text-name"><span class="label">投/被保险人：</span>{{ item.holderName }}/{{ item.insuranceName }}</div>
                <div class="text gift" v-if="item.isGift == 1">0元投保</div>
                <div class="text" v-else><span class="label">保费：</span>{{ item.fee }}元</div>
              </div>
              <div class="right-box" v-if="showRightBox(item)">
                <div v-if="!$tools.isXXB() && (item.policyStatus == 1 || (item.policyStatus == 0 && item.orderStatus == 2))" class="text-box">
                  <div class="text1">+{{ item.income || 0 }}元</div>
                  <div class="text2">首期收入</div>
                </div>
                <div v-else-if="item.policyStatus == -1 && item.income && !$tools.isXXB()" class="text-box">
                  <div class="text1">{{ item.income || 0 }}元</div>
                  <div class="text2">首期收入</div>
                </div>
                <div v-else-if="item.checkInsuranceStatus == 2"></div>
              </div>
            </div>
            <div class="bottom-wrap">
              <div class="btn ok-bgcolor" v-if="item.orderStatus == 1 && item.checkInsuranceStatus == 1" @click.stop="sharePay(item)">继续支付</div>
              <div class="btn ok-bgcolor" v-if="item.orderStatus == 1 && item.checkInsuranceStatus == 2" @click.stop="openWeb(item.manualUrl)">人核进度</div>
              <div class="btn ok-bgcolor" v-if="showCXTB(item)" @click.stop="shareProduct(item)">重新投保</div>
            </div>
          </div>
        </van-cell>
        <div class="null" v-if="list.length <= 0 && !listLoading">
          <img class="null-img" src="@static/images/null.png" />
          <span class="null-text">暂无内容</span>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { pageTools, common } from '@/api/mixins';
export default {
  mixins: [pageTools, common],
  props: {
    url: null,
    isOrder: null,
  },
  data() {
    return {
      list: [],
      userInfo: JSON.parse(localStorage.getItem('jzy_user') || '{}')
    };
  },
  watch: {},
  mounted() {
    console.log(this.$parent);
  },
  methods: {
    openWeb(url) {
      this.$app.openWeb(url);
    },
    showReceiptRevisit(detail) {
      if (detail.receiptStatus == '0' || detail.receiptStatus == '3') {
        return '-待回执';
      } else if (detail.receiptStatus == '2') {
        return '-回执失败';
      } else if (detail.revisitStatus == '0' || detail.revisitStatus == '4') {
        return '-待回访';
      } else if (detail.revisitStatus == '2') {
        return '-回访失败';
      } else if (detail.revisitStatus == '' || detail.revisitStatus == '') {
        return '';
      } else {
        return '-回执回访成功';
      }
    },
    goDetail(item) {
      if (this.$config.isApp) {
        this.$app.openWeb(location.origin + `/apps/order/orderDetail?orderNo=${item.orderNo}`);
      } else {
        this.goPage('/apps/order/orderDetail', { orderNo: item.orderNo });
      }
    },
    init(url) {
      this.pageNum = 1;
      this.initListAjax(url);
    },
    // 设置自定义参数
    setListParams(params) {
      this.$emit('setListParams', params);
    },
    listCallback(res) {
      this.$emit('listCallback', res);
    },
    // 分享支付
    sharePay(item) {
      console.log(item);
      const shareData = {
        title: '您有一笔订单待支付，请及时完成付款！',
        link: location.origin + '/apps/jump.html?p=' + item.payUrl,
        content: '产品名称:' + item.productName + ';投保人:' + item.holderName + ';保费:' + item.fee, //分享的描述,
        logo: item.productImg,
        apiPermissionCode: 'APP_ORDER_SHARE'
      };
      if (this.$config.isApp) {
        this.openSharePanel(shareData, true);
      } else {
        this.shareInit(shareData, true);
        this.$emit('changeYindao');
      }
    },
    // 分享产品
    shareProduct(item) {
      const shareData = {
        title: item.productName,
        link: location.origin + '/apps/jump.html?p=' + item.productUrl,
        content: item.productDesc, //分享的描述,
        logo: item.productImg,
        apiPermissionCode: 'APP_ORDER_SHARE'
      };
      if (this.$config.isApp) {
        this.openSharePanel(shareData, true);
      } else {
        this.shareInit(shareData);
        this.$emit('changeYindao');
      }
    },
    // 显示重新分享按钮
    showCXTB(detail) {
      return (
        (detail.orderStatus == 1 && [3, 4].includes(detail.checkInsuranceStatus * 1)) || [3, 4].includes(detail.orderStatus * 1) || detail.policyStatus == -1
      );
    },
    // 是否显示右边box
    showRightBox(detail) {
      if (!detail.income * 1) return false;
      return (
        ['1', '-1'].includes(detail.policyStatus) ||
        (detail.policyStatus == 0 && detail.orderStatus == 2) ||
        this.showCXTB(detail) ||
        (detail.orderStatus == 1 && ['1', '2'].includes(detail.checkInsuranceStatus))
      );
    }
  }
};
</script>
<style lang="scss" scoped>
@import './list.scss';
</style>
